import React, {useState} from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import {CopyToClipboard} from 'react-copy-to-clipboard';
import {Link} from 'react-router-dom'
import Ulasan from './ulasan_ber'
import CardProduk from 'components/dashboard/dashcomp/card_produk'
import Checkout from './ber_checout'
import './style.css'

export default function Main() {

    const [clickImg, setClickImg] = useState()
    const [message, setMessage] = useState(false)

    let paragraph = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mattis integer bibendum pretium a fermentum congue diam proin diam. Quam interdum et elementum, non, pellentesque. Consectetur ultricies aliquam, vivamus tortor tincidunt tortor, arcu ornare. Risus, fermentum, turpis eget porttitor id congue proin adipiscing. Augue malesuada facilisi risus, vestibulum, feugiat risus facilisis magnis donec. Lorem enim posuere vulputate blandit sit ut sed amet metus."

    // copied..
    let messageHandler = () => {
        setMessage(true)
         const tiemr = setTimeout(() => setMessage(false), 1000);
         return () => {
            clearTimeout(tiemr);
        }
    }

    return (
        <Container className="product-page">
            <Row>
                <Col md={4}>
                    <div className="gambar">
                        <img src={clickImg ? clickImg : "asset/product/kitab.png"} alt="kitab" />
                        <div className="icon-toko">
                            <img src="asset/product/icon-toko.svg" alt="toko" />
                        </div>
                        <div className="icon-download">
                            <img src="asset/product/download.svg" alt="download" />
                        </div>
                    </div>
                        <div className="thumb-text">
                            <small>{`${Images.length} images`}</small>
                        </div>
                        <div className="thumb-img">
                            {
                                Images.map((img, i) => {
                                    return (
                                            <img key={i} src={img.src} alt="product-zoom" onClick={_ => setClickImg(img.src)} />
                                    )
                                })
                            }
                        </div>
                        <div className="profile">
                            <img className="img-profile" src="asset/product/cordova.png" alt="cordova" />
                            <div className="profile-text">
                                <h3>Cordova</h3>
                                <p>Makassar</p>
                                <p><img src="asset/product/start.svg" alt="start" /> 5.0</p>
                            </div>
                        </div>
                        <div className="input">
                            <input type="text" id="id_penjual" name="penjual" placeholder="Chat Penjual" />
                            <img src="asset/product/plus-form.svg" alt="plus-form" />
                        </div>
                </Col>
                <Col md={4}>
                        <div className="content-text">
                            <Link to="#">Buku</Link>
                            <h3>Kitab Riyadhusshalihin Karya Imam An Nawawi</h3>
                            <h2>Rp. 120.000</h2>
                            <div className="text-p">    
                                <p className="barang">Terjual 4931 Barang <img src="asset/product/start.svg" alt="start" /> 4.9</p>
                                <p>{paragraph}</p>
                                <CopyToClipboard text={paragraph}>
                                  <p className="copy-text" onClick={messageHandler}> {message ? "copy.." : "Salin Deskripsi"} </p> 
                                </CopyToClipboard>
                            </div>
                        </div>
                        <div className="content-variant">
                            <h6>Variant</h6>
                            <select class="form-select" aria-label="Default select example">
                                <option selected>Pilih Varian</option>
                                <option value="Abu-Abu">Abu-Abu</option>
                                <option value="Merah">Merah</option>
                                <option value="Orange">Orange</option>
                                <option value="Hijau">Hijau</option>
                                <option value="Biru">Biru</option>
                            </select>
                            <div className="variant-2">
                                <p>Variant 2 Jika Ada</p>
                                <select class="form-select" aria-label="Default select example">
                                    <option selected>Pilih Varian</option>
                               </select>
                            </div>
                            <div className="alamat">
                                <span>Pengirim</span>
                                {
                                    DetileTujuan.map((item, i) => {
                                        return (
                                            <div key={i} className="detile-tujuan">
                                                <img src={`${item.icon}.svg`} alt="icon" />
                                                <p>{item.text} <span>{item.span}</span> </p>
                                            </div>
                                        )
                                    })
                                }
                                <div className="small">
                                    <small>Estimasi Tiba 4 Agu - 7 Agu</small>
                                    <Link to="#">Atur Alamat</Link>
                                </div>
                            </div>
                        </div>
                </Col>
                <Col md={4}>
                    <Checkout />
                </Col>
            </Row>
            <Ulasan />
            <h3 className="produk-lain">Produk Lain dari (Nama Toko)</h3>
            <Row>
                {
                    Produks.map((item, i) => {
                        return (
                            <CardProduk key={i}
                            header={item.header}
                            src={`asset/cart/${item.src}${i + 1}.png`} 
                            alt="produk"
                            text={item.text} potongan={item.potongan}
                            price={item.price} shere="Bagikan Produk"
                            />
                        )
                    })
                }
            </Row>
        </Container>
    )
}

let Images = [
    {src:"asset/product/kitab.png"},{src:"asset/product/al-qur'an.png"},{src:"asset/product/kurma.png"}
]

const DetileTujuan = [
    {icon:"asset/product/lokasi", text:"Dari", span:"Manggala"},{icon:"asset/product/titik_tujuan", text:"Dikirim Ke", span:"Parigi"},{icon:"asset/product/car", text:"Ongkir", span:"Rp.43.000 - Rp. 86.000"}
]
// src:"asset/product/kucing.mp4"

const Produks = [
{src:"gambar", header:"Komisi 15%", text:"Sensi Duckbill Original / Sensi Mask Duckbill ...", potongan:"Rp. 137.000", price:"Rp. 100.000" },
{src:"gambar", header:"Komisi 10%", text:"Alquran Hafalan Tajwid Warna ...", potongan:"Rp. 95.000", price:"Rp. 73.000" },
{src:"gambar", header:"Komisi 15%", text:"Kurma Tunisia Tangkai Timur Tengah ...", potongan:"Rp. 48.500", price:"Rp. 30.000" },
{src:"gambar", header:"Komisi 15%", text:"Sensi Duckbill Original / Sensi Mask Duckbill ...", potongan:"Rp. 137.000", price:"Rp. 100.000" },
{src:"gambar", header:"Komisi 10%", text:"Alquran Hafalan Tajwid Warna ...", potongan:"Rp. 95.000", price:"Rp. 73.000" },
{src:"gambar", header:"Komisi 15%", text:"Kurma Tunisia Tangkai Timur Tengah ...", potongan:"Rp. 48.500", price:"Rp. 30.000" }
]